import { defineComponent as _defineComponent } from 'vue'
import { ref as _ref, computed as _computed } from 'vue';

import type { VForm } from '@/@types/types';
import { onMounted, useSlots, inject } from 'vue';

import { VTextField } from 'vuetify/lib/components';

interface STextFieldProps {
  eagerlyValidate?: boolean;
  rules?: any[];
}

export default /*#__PURE__*/_defineComponent({
  __name: 'STextField',
  props: {
  eagerlyValidate: { type: Boolean, default: false },
  rules: { default: () => [] }
},
  setup(__props) {

const props = __props;


const vuetifyForm = inject<VForm | null>('form', null);

const slots = useSlots();

const textField = _ref<(InstanceType<typeof VTextField> & { validate: () => boolean }) | null>(null);

const hasPrependText = _computed(() => !!slots['prepend-text']);

onMounted(() => {
  if (props.eagerlyValidate) {
    vuetifyForm?.validate();
  }
});


return { __sfc: true,props, vuetifyForm, slots, textField, hasPrependText, _ref, _computed, onMounted, useSlots, inject, VTextField }
}

})